import React, { Component } from "react";
import generateContentDataObject from "../../helpers/editor/generateContentDataObject";
import { callToActionOptions } from "../../data/callToActionOptions";
import { buttonStyles } from "../../data/buttonStyles";
import { linkOrButtonOptions } from "../../data/linkOrButtonOptions";
import { GraphicsOptions } from "../../components/editor/component_graphics/data/componentGraphicsData";
import _ from "lodash";
import GraphicsJSX from "../GraphicsJSX";
import { displayImageUrl } from "../../helpers/content_displayers/displayImageUrl";
import { displayTitleMarkupText } from "../../helpers/content_displayers/displayTitleMarkupText";
import { displaySubtitleMarkupText } from "../../helpers/content_displayers/displaySubtitleMarkupText";
import WebsiteCTA from "../component_molecules/WebsiteCTA";
import { DEFAULT_IMAGES_CDN } from "../../data/urls";

interface Props {
  componentItem: any;
  checkIsEmptyContent: any;
  saveContentInStore: any;
  displayButtons: any;
  isDarkBg: boolean;
}

class Features06 extends Component<Props> {
  generator = new generateContentDataObject();

  componentWillMount(): void {
    const { isDefaultEmpty } = this.props.componentItem;
    //check if the component has not content (when just added). if so, generate some default dummy content.
    // also change inputs tooltips, placeholders text if needed. E.g. when a component needs an image of a particular size.
    if (this.props.checkIsEmptyContent()) {
      //generate defaultContent{}. Use special methods of the generateContentDataObject class;
      this.props.saveContentInStore(
        this.generator.setUpGraphics({
          activeOption: GraphicsOptions.image,
          userCanAddItems: false,
          maxItems: 1,
          items: [
            this.generator.createGraphicsContentObject({
              imageUrl: DEFAULT_IMAGES_CDN.UI_DESKTOP_CALENDAR,
              videoUrl: "https://www.youtube.com/watch?v=tw4jkyfY4HE",
              width: 1280,
              height: 800,
            }),
          ],
        })
      );
      this.props.saveContentInStore(
        this.generator.setUpTitle({
          titleText: "Because Your Startup Deserves the Best",
          isDefaultEmpty
        })
      );
      this.props.saveContentInStore(this.generator.setUpSubtitleText({isDefaultEmpty}));

      this.props.saveContentInStore(
        this.generator.setUpCta({
          isDefaultEmpty,
          activeOption: callToActionOptions.buttons,

          fieldTitle: {
            [callToActionOptions.buttons]: "Buttons",
            default: "Buttons",
          },
          label: {
            [callToActionOptions.buttons]: "Edit the buttons:",
            default: "Edit the buttons:",
          },
          labelTooltip: {
            [callToActionOptions.buttons]:
              "Add a CTA (call to action) to the feature. It can be a link to a '/features' page so users can learn more about your product.",
            default:
              "Add a CTA (call to action) to the feature. It can be a link to a '/features' page so users can learn more about your product.",
          },
          buttons: [
            this.generator.createButtonContentObject({
              buttonType: linkOrButtonOptions.link,
              buttonTitle: "",
              buttonHref: "",
              buttonStyleType: buttonStyles.regular.typeTitle,
              buttonColor: buttonStyles.regular.blackBg,
              pillPrefix: "See",
            }),
          ],
          priority: 10,
        })
      );
    }
  }

  render() {
    // these variables contain content. we need to wait a little before content schemes with default data will be populated (it happens on the componentWillMount even, each time we launch generator).
    // see the content schema in the helpers/editor/generateContentDataObject.ts
    let title = displayTitleMarkupText(
      this.props.componentItem.componentData.title.content.markup
    );
    let subtitleText = displaySubtitleMarkupText(
      this.props.componentItem.componentData.subtitleText.content.markup
    );
    let imageUrl = displayImageUrl(
      this.props.componentItem.componentData.graphics.content.items[0][
        GraphicsOptions.image
      ]
    ); //This component has exactly one item and more can not be added (see createGraphicsContentObject() above).

    const currentActiveOption: GraphicsOptions = _.get(
      this.props.componentItem,
      ["componentData", "graphics", "activeOption"]
    );
    const videoUrl: string = _.get(this.props.componentItem, [
      "componentData",
      "graphics",
      "content",
      "items",
      "0",
      GraphicsOptions.video,
      "youtube",
      "url",
    ]);
    const codeSnippet: string = _.get(this.props.componentItem, [
      "componentData",
      "graphics",
      "content",
      "items",
      "0",
      GraphicsOptions.HTML,
      "codeSnippet",
    ]);

    return (
      <section>
        <div
          className={`features-06 graphics-${currentActiveOption} default-graphics-${GraphicsOptions.image}`}
        >
          <div className="container container--large">
            <div className="features-06__wrapper">
              <div className="features-06__main">
                <div className="features-06__main_content">
                  <div className="title-box">
                    {title.length > 0 && (
                      <h2
                        className={
                          "title-text heading features-06__heading " +
                          (this.props.isDarkBg ? "text-white" : "")
                        }
                        dangerouslySetInnerHTML={{ __html: title }}
                      />
                    )}
                    {subtitleText.length > 0 && (
                      <div
                        className={
                          "subtitle-text title-box__text features-06__text content_box " +
                          (this.props.isDarkBg ? "text-white" : "")
                        }
                        dangerouslySetInnerHTML={{ __html: subtitleText }}
                      />
                    )}
                  </div>

                  {this.props.componentItem.componentData.cta &&
                    <WebsiteCTA componentItem={this.props.componentItem} isDarkBg={this.props.isDarkBg} />
                    }
                </div>
              </div>
              <div className="features-06__visual">
                <div className="features-06__img_box">
                  <GraphicsJSX
                    currentActiveOption={currentActiveOption}
                    defaultGraphicsOption={GraphicsOptions.image}
                    isDarkBg={this.props.isDarkBg}
                    imageUrl={imageUrl}
                    videoUrl={videoUrl}
                    codeSnippet={codeSnippet}
                    classNames={{
                      image: "features-06__img",
                      video: "features-06__video",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Features06;
